import { useEffect } from "react";

import Box from "@mui/material/Box";

import NavComponent from "components/templates/nav/NavComponent";

import { Outlet, useParams } from "react-router-dom";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { companyInfoAtom, isLayoutPage, isNavOpen } from "recoil/store";

import { motion } from "framer-motion";
import { jwtDecoder } from "utils/jwtDecoder";
import MainContainer from "./loginPageLayout";

export default function Content() {
  const isOpen = useRecoilValue(isNavOpen);
  const isLayout = useRecoilValue(isLayoutPage);
  const companyInfo = useSetRecoilState(companyInfoAtom);
  const { company } = useParams();

  useEffect(() => {
    companyInfo(jwtDecoder(sessionStorage.getItem(company) || localStorage.getItem(company)));
  }, [company]);

  return (
    <Box sx={{ display: "flex", background: "#f8f9fa" }}>
      {!isLayout && <NavComponent />}
      <MainContainer open={isOpen} islayout={isLayout.toString()}>
        <motion.div
          // className="container text-center"
          style={{ height: "100%" }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Outlet />
        </motion.div>
      </MainContainer>
    </Box>
  );
}
